import { StyleParamType, createStylesParams } from '@wix/tpa-settings';
import { RssWidgetIconType } from '@wix/communities-blog-client-common';

export default createStylesParams<{
  'widget-iconColor': StyleParamType.Color;
  'widget-iconBackgroundColor': StyleParamType.Color;
  'widget-iconColorNoBackground': StyleParamType.Color;
  'widget-iconBackgroundType': StyleParamType.Number;
}>({
  'widget-iconColor': {
    type: StyleParamType.Color,
    getDefaultValue: () => ({
      value: 'rgb(255,255,255)',
      name: null,
      opacity: 1,
    }),
  },
  'widget-iconBackgroundColor': {
    type: StyleParamType.Color,
    getDefaultValue: () => ({
      value: 'rgb(250,173,77)',
      name: null,
      opacity: 1,
    }),
  },
  'widget-iconColorNoBackground': {
    type: StyleParamType.Color,
    getDefaultValue: () => ({
      value: 'rgb(250,173,77)',
      name: null,
      opacity: 1,
    }),
  },
  'widget-iconBackgroundType': {
    type: StyleParamType.Number,
    getDefaultValue: () => RssWidgetIconType.Square,
  },
});
